import styles from './recruit.module.scss'

const PrivacyRecruit: React.FC = () => {
  return (
    <article className={styles.privacy_page}>
      <section className={styles.title_group}>
        <h2 className={styles.title}>採用応募における個人情報の取扱いについて</h2>
      </section>
      <ul>
        <li>
          <p className={styles.list_title}>（１）事業者の氏名または名称</p>
          <p className={styles.list_text}>株式会社アイスリーデザイン</p>
        </li>
        <li>
          <p className={styles.list_title}>
            （２）個人情報保護管理者（若しくはその代理人）の氏名又は職名、所属及び連絡先
          </p>
          <p className={styles.list_text}>
            個人情報保護管理者：大森 康宏
            <br />
            電子メール：pms_mgmt@i3design.co.jp
            <br />
            電話番号：03-6419-7700
          </p>
        </li>
        <li>
          <p className={styles.list_title}>（３）個人情報の利用目的</p>
          <p className={styles.list_text}>
            採用に係わる業務に利用するため（採用に関する情報提供、採用可否判断、採用業務に関する連絡など）
          </p>
        </li>
        <li>
          <p className={styles.list_title}>（４）個人情報の第三者提供について</p>
          <p className={styles.list_text}>
            取得した個人情報は法令等による場合を除いて第三者に提供することはありません。
          </p>
        </li>
        <li>
          <p className={styles.list_title}>（５）個人情報の取扱いの委託について</p>
          <p className={styles.list_text}>
            取得した個人情報の取扱いについて、データ保管時に外部へ委託することがあります。
          </p>
        </li>
        <li>
          <p className={styles.list_title}>（６）個人情報を与えなかった場合に生じる結果</p>
          <p className={styles.list_text}>
            個人情報を与えることは任意です。個人情報に関する情報の一部をご提供いただけない場合は、採用応募に対応できない可能性があります。
          </p>
        </li>
        <li>
          <p className={styles.list_title}>（７）保有個人データの開示等および問い合わせ窓口について</p>
          <p className={styles.list_text}>
            ご本人からの求めにより、当社が保有する保有個人データに関する開示、利用目的の通知、内容の訂正・追加または削除、利用停止、消去および第三者提供の停止（以下、開示等という)に応じます。
            <br />
            開示等に応ずる窓口は、下記「当社の個人情報の取扱いに関する苦情、相談等の問合せ先」を参照してください。
          </p>
        </li>
        <li>
          <p className={styles.list_title}>（８）本人が容易に認識できない方法による個人情報の取得</p>
          <p className={styles.list_text}>
            クッキーやウェブビーコン等を用いるなどして、本人が容易に認識できない方法による個人情報の取得を行うことがあります。
          </p>
        </li>
        <li>
          <p className={styles.list_title}>（９）個人情報の安全管理措置について</p>
          <p className={styles.list_text}>
            取得した個人情報については、漏洩、減失またはき損の防止と是正、その他個人情報の安全管理のために必要かつ適切な措置を講じます。
            <br />
            お問合せへの回答後、取得した個人情報は当社内において削除致します。
          </p>
        </li>
        <li>
          <p className={styles.list_title}>（１０）個人情報保護方針</p>
          <p className={styles.list_text}>当社ホームページの個人情報保護方針をご覧下さい。</p>
        </li>
        <li>
          <div>
            <p className={styles.list_title}>（１１）当社の個人情報の取扱いに関する苦情、相談等の問合せ先</p>
            <table className={styles.bottom_table}>
              <thead>
                <tr className={styles.table_column_title}>
                  <th className={styles.th}>窓口の名称</th>
                  <td className={styles.td}>個人情報問合せ窓口</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th className={styles.th}>連絡先</th>
                  <td className={styles.td}>
                    <p>窓口責任者：個人情報保護管理者</p>
                    <p>住所：〒107-0052 東京都港区赤坂八丁目１番22号 NMF青山一丁目ビル３階</p>
                    <p>電話/FAX：03-6419-7700 / 03-6419-7703</p>
                    <p>電子メール：pms_mgmt@i3design.co.jp</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </li>
      </ul>
    </article>
  )
}

export default PrivacyRecruit
